<div style="height: calc(100%); width: 100%;" data-cy="draw-canvas-container">
  <mat-grid-list cols="5" rowHeight="100%" style="height:100%;" data-cy="draw-canvas-grid">
    <mat-grid-tile colspan="5" data-cy="draw-canvas-tile">
      <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-canvas-card">
        <span class="configuration-section-title" data-cy="draw-canvas-title">Gradient Object</span>
        <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onSave($event)" data-cy="draw-canvas-action-bar"></app-tdo-configuration-action-bar>
        <div style="display: flex;" data-cy="draw-canvas-header-spacer">
        </div>
        <mat-card-subtitle data-cy="draw-canvas-subtitle">Use the following properties to create the default canvas size and the gradient.</mat-card-subtitle>
        <br />
        <div style="display: flex; width: 400px;  margin-bottom: 8px;" data-cy="draw-canvas-width-container">
          <div style="flex-basis: 200px; height: 75px;" data-cy="draw-canvas-width-field">
            <label style="flex:1; text-align: left;" class="col-10 col-form-label" data-cy="draw-canvas-width-label">Canvas Width</label>
            <input style="flex:1" type="number" min="300" class="col-10 form-control" [value]="width"
                   (input)="width = $event.target.value; configurationService.setDirty();" data-cy="draw-canvas-width-input">
          </div>
        </div>
        <div style="display: flex; width: 400px;  margin-bottom: 8px;" data-cy="draw-canvas-height-container">
          <div style="flex-basis: 200px; height: 100px;" data-cy="draw-canvas-height-field">
            <label style="flex:1; text-align: left;" class="col-10 col-form-label" data-cy="draw-canvas-height-label">Canvas Height</label>
            <input style="flex:1" type="number" min="300" class="col-10 form-control" [value]="height"
                   (input)="height = $event.target.value; configurationService.setDirty();" data-cy="draw-canvas-height-input">
          </div>
        </div>

        <div style="display: flex; width: 300px;" data-cy="draw-canvas-colors-container">
          <app-tdo-color-picker [width]="24" [height]="24" label="Start Color" style="flex: 1; margin-left: 10px;" placeholder="End color" [color]="startColor" (colorChange)="onStartColorChange($event); configurationService.setDirty();" data-cy="draw-canvas-start-color"></app-tdo-color-picker>
          <app-tdo-color-picker [width]="24" [height]="24" label="End Color" style="flex: 1; margin-right: 10px;" placeholder="End color" [color]="endColor" (colorChange)="onEndColorChange($event); configurationService.setDirty();" data-cy="draw-canvas-end-color"></app-tdo-color-picker>
        </div>
        <br />
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
